import styled from "@emotion/styled";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { Grid } from "@mui/material";
import ImageList from "../ImageList";
import { CharityDonation } from "./CharityDonation";
import { CartButton } from "./ImageComponents";

const ImageTile = styled.div`
  display: block;
  max-width: 300px;
`;

const ImageTitle = styled.h2`
  text-align: left;
  margin: 5pt 0pt;
`;

const ImageDescription = styled.p`
  margin: 5pt 0pt;
`;

const Gallery = () => {
  return (
    <Grid
      container
      columnGap={10}
      rowGap={10}
      width={"100%"}
      justifyContent={"center"}
      columns={4}
    >
      {ImageList.map((element) => {
        return element.prints?.etsyUrl && (
          <Grid item key={`${element.id}`}>
            <ImageTile id={element.id}>
              <img
                src={`/images/prints/${element.id}/300.jpeg`}
                width={"100%"}
                alt={element.title}
              />
              <ImageTitle>{element.title}</ImageTitle>
              <ImageDescription>{element.prints.shortText}</ImageDescription>
              <CartButton variant="contained" size="small" href={element.prints?.etsyUrl} startIcon={<AddShoppingCartIcon />}>Buy on Etsy</CartButton>
              <CharityDonation />
            </ImageTile>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Gallery;
